var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    class: {
      disabled: _vm.currentPage == 1
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.update(_vm.currentPage - 1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_left")])])]), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.currentPage == 1
    }
  }, [_c('a', {
    staticClass: "waves-effect",
    on: {
      "click": function($event) {
        _vm.update(1)
      }
    }
  }, [_vm._v("1")])]), _vm._v(" "), _vm._l((_vm.offset), function(items, index) {
    return (index != 0 && _vm.currentPage < _vm.offset) ? _c('li', {
      class: {
        disabled: _vm.currentPage == items
      }
    }, [_c('a', {
      staticClass: "waves-effect",
      on: {
        "click": function($event) {
          _vm.update(items)
        }
      }
    }, [_vm._v(_vm._s(items))])]) : _vm._e()
  }), _vm._v(" "), (_vm.maxPage > _vm.maxOffset && _vm.currentPage >= _vm.offset) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', [_vm._v("...")])]) : _vm._e(), _vm._v(" "), (_vm.currentPage >= _vm.offset && _vm.currentPage <= _vm.maxPage - _vm.maxOffset + 1) ? _c('li', [_c('a', {
    staticClass: "waves-effect",
    on: {
      "click": function($event) {
        _vm.update(_vm.currentPage - 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.currentPage - 1))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage >= _vm.offset && _vm.currentPage <= _vm.maxPage - _vm.maxOffset + 1) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    staticClass: "waves-effect",
    on: {
      "click": function($event) {
        _vm.update(_vm.currentPage)
      }
    }
  }, [_vm._v(_vm._s(_vm.currentPage))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage >= _vm.offset && _vm.currentPage <= _vm.maxPage - _vm.maxOffset + 1) ? _c('li', [_c('a', {
    staticClass: "waves-effect",
    on: {
      "click": function($event) {
        _vm.update(_vm.currentPage + 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.currentPage + 1))])]) : _vm._e(), _vm._v(" "), (_vm.maxPage > _vm.maxOffset && _vm.currentPage <= _vm.maxPage - _vm.maxOffset + 1) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.offset), function(items, index) {
    return (_vm.maxPage > _vm.maxOffset && index != _vm.maxOffset - 1 && _vm.currentPage >= (_vm.maxPage - _vm.maxOffset + 2)) ? _c('li', {
      class: {
        disabled: _vm.currentPage == items + _vm.maxPage - _vm.maxOffset
      }
    }, [_c('a', {
      staticClass: "waves-effect",
      on: {
        "click": function($event) {
          _vm.update(items + _vm.maxPage - _vm.maxOffset)
        }
      }
    }, [_vm._v(_vm._s(items + _vm.maxPage - _vm.maxOffset))])]) : _vm._e()
  }), _vm._v(" "), (_vm.maxPage > _vm.maxOffset) ? _c('li', {
    class: {
      disabled: _vm.currentPage == _vm.maxPage
    }
  }, [_c('a', {
    staticClass: "waves-effect",
    on: {
      "click": function($event) {
        _vm.update(_vm.maxPage)
      }
    }
  }, [_vm._v(_vm._s(_vm.maxPage))])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.currentPage == _vm.maxPage
    }
  }, [_c('a', {
    staticClass: "waves-effect",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.update(_vm.currentPage + 1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")])])])], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eff4c5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = SQJ4
// module chunks = 1